<template>
  <div>
    <div class="carousel">
      <conference-images></conference-images>
    </div>
    <div class="search-box mb-5">
      <search-customer-booking></search-customer-booking>
    </div>
  </div>
</template>

<script>
import ConferenceImages from "../components/ConferenceImages";
import SearchCustomerBooking from "../components/SearchCustomerBooking";

export default {
  components: {
    "search-customer-booking": SearchCustomerBooking,
    ConferenceImages,
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables.scss";

.search-box {
  padding: 50px 90px 90px 150px;
}

@media screen and (max-width: $ml-size) {
  .search-box {
    padding: 0 20px 0 20px;
  }
}
</style>